// priceFormUtils.js
import { stationDisplaysCurrency } from "./currencyDisplayMode";

export const DEFAULT_EMPTY_PRICE = () => ({
  value: null,
  originalValue: null,
  source: "manual",
  confirmed: 1,
  created_at: null,
  confirmed_at: null,
  confirmed_by_user_id: null,
  confirmed_by_username: null,
  id: null,
  dirty: false,
});

export const isEurAllowed = (station, fuel) => {
  if (!stationDisplaysCurrency(station, "EUR")) return false;
  // TF* nikdy nemají EUR
  if (fuel === "TF zboží" || fuel === "TF cig" ) return false;
  return true;
};

export const normalizeDecimalInput = (raw, decimals) => {
  if (raw == null) return "";
  let s = String(raw).replace(/,/g, ".");
  s = s.replace(/[^\d.]/g, "");
  const firstDot = s.indexOf(".");
  if (firstDot !== -1) {
    s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, "");
  }
  if (s.startsWith(".")) s = "0" + s;
  const [whole, frac = ""] = s.split(".");
  if (firstDot !== -1) return `${whole}.${frac.slice(0, decimals)}`;
  return whole;
};

export const toNumberOrNull = (normalized) => {
  if (normalized === "") return null;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
};

export const decimalsForCurrency = (currency) =>
  currency === "CZK" ? 2 : currency === "EUR" ? 3 : 3;

export const fieldKey = (stationId, fuel, currency) => `${stationId}-${fuel}-${currency}`;

// Normalize prices according to backend allowed_by_station (explicit!)
export const normalizeStationPrices = ({ station, allowedFuels, currencies }) => {
  const src = station?.prices ?? {};
  const out = {};

  const safeAllowed = Array.isArray(allowedFuels) ? allowedFuels : [];
  const safeCurrencies = Array.isArray(currencies) ? currencies : ["CZK"]; // fallback

  for (const fuel of safeAllowed) {
    out[fuel] = out[fuel] || {};
    for (const cur of safeCurrencies) {
      const incoming = src?.[fuel]?.[cur];
      out[fuel][cur] = incoming
        ? {
            ...DEFAULT_EMPTY_PRICE(),
            ...incoming,
            originalValue: incoming?.value ?? null,
            source: incoming?.source ?? "manual",
          }
        : DEFAULT_EMPTY_PRICE();
    }
  }

  return out;
};



export const clearDirtyForStation = (station) => {
  const next = { ...station, prices: { ...station.prices } };
  for (const fuel of Object.keys(next.prices || {})) {
    next.prices[fuel] = { ...next.prices[fuel] };
    for (const cur of Object.keys(next.prices[fuel] || {})) {
      next.prices[fuel][cur] = { ...next.prices[fuel][cur], dirty: false };
    }
  }
  return next;
};

export const getLimitRange = (limits, fuel) => {
  const safe = Array.isArray(limits) ? limits : [];
  const minL = safe.find((l) => l.price_type === fuel && l.role === "min");
  const maxL = safe.find((l) => l.price_type === fuel && l.role === "max");
  const min = minL ? Number(minL.value) : 0;
  const max = maxL ? Number(maxL.value) : 0;
  return { min: Math.min(min, max), max: Math.max(min, max) };
};

export const isFinitePositive = (v) => Number.isFinite(Number(v)) && Number(v) > 0;

export const shouldIncludeRow = ({
  station,
  fuel,
  currency,
  price,
  eurAllowedFuels,
  includeUnchanged = false,
}) => {
  if (currency === "EUR") {
    if (!stationDisplaysCurrency(station, "EUR")) return false;
    if (!eurAllowedFuels?.has(fuel)) return false;
  }

  if (currency === "CZK" && !stationDisplaysCurrency(station, "CZK")) return false;

  if (includeUnchanged) {
    return true;
  }

  return price?.dirty === true;
};

      export const buildSubmitRowsForStation = ({
  station,
  userId,
  validFrom,
  mode,
  eurAllowedFuels,
  armexStationId = null,
  includeUnchanged = false,
}) => {
  const rows = [];

  for (const [fuel, currencyData] of Object.entries(station.prices || {})) {
    for (const [currency, price] of Object.entries(currencyData || {})) {
      if (
        !shouldIncludeRow({
          station,
          fuel,
          currency,
          price,
          eurAllowedFuels,
          includeUnchanged,
        })
      ) {
        continue;
      }

      const v = price?.value;

      if (v == null || v === "" || !Number.isFinite(Number(v)) || Number(v) <= 0) {
        continue;
      }

      rows.push({
        station_id: station.id,
        ...(mode === "user" && armexStationId
          ? { armex_station_id: armexStationId }
          : {}),
        fuel_type: fuel,
        currency,
        value: Number(v),
        updated_by: userId,
        confirmed: mode === "user" ? 0 : 1,
        ...(mode === "schedule" ? { valid_from: validFrom } : {}),
      });
    }
  }

  return rows;
};



